import React from 'react';
import clsx from 'clsx';

interface TournamentFlagsProps {
    listOfIcons: Map<string, string>[];
    sizeX?: string | number;
    sizeY?: string | number;
    className?: string;
}

export const TournamentFlags = ({ listOfIcons, sizeX = '16px', sizeY = '16px', className }: TournamentFlagsProps) => {
    return (
        <>
            {listOfIcons?.map((obj, index) =>
                obj ? (
                    <img
                        key={index}
                        src={obj?.get('teamLogo') || obj?.get('flag')}
                        width={sizeX}
                        height={sizeY}
                        className={clsx('ml-10', className)}
                        alt="Tournament flag"
                    />
                ) : null
            )}
        </>
    );
};
